(function($) {

  [
    $('.Feature.Rating .stars-avg-rating .rating-text'),
    $('#respond .comment-reply-title'),
    $('#respond .comment-questions')
  ]
  .forEach($element => $element.html(__($element.html())))

  const $ratingtext = $('.Feature.Rating .stars-avg-rating .rating-text')
  if(
    $ratingtext.length
    &&
    $ratingtext.html()
    .includes('based on')
  ) {

    $ratingtext.html(
      $ratingtext.html()
      .split('based on')
      .join(__('based on'))
      .split('reviews')
      .join(__('reviews'))
    )
  }

})(jQuery)